import { jsx, jsxs } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { AdornedInput, FormField, Label, Tooltip, Paragraph } from "@zillow/constellation-10";
import React from "react";
const inputRootCss = css.raw({
  backgroundColor: "gray.50",
  boxShadowColor: "gray.300"
});
const inputNumberCss = css.raw({
  "&::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: "0"
  },
  "&::-webkit-outer-spin-button": {
    WebkitAppearance: "none",
    margin: "0"
  },
  appearance: "textfield"
});
const InputTooltip = ({
  toolTipHeader,
  toolTipStatement
}) => /* @__PURE__ */ jsxs(Tooltip.Root, { children: [
  /* @__PURE__ */ jsx(Tooltip.Trigger, {}),
  /* @__PURE__ */ jsx(Tooltip.Portal, { children: /* @__PURE__ */ jsxs(Tooltip.Content, { children: [
    /* @__PURE__ */ jsxs(React.Fragment, { children: [
      /* @__PURE__ */ jsx(Paragraph, { children: toolTipHeader }),
      /* @__PURE__ */ jsx("br", {}),
      /* @__PURE__ */ jsx(Paragraph, { children: toolTipStatement })
    ] }),
    /* @__PURE__ */ jsx(Tooltip.Arrow, {})
  ] }) })
] });
class RentVsBuyInputField extends React.Component {
  render() {
    const {
      inputLabel,
      value,
      onChange,
      toolTipHeader,
      toolTipStatement,
      percentageQuestion,
      perMonth
    } = this.props;
    const startAdornmentProps = !percentageQuestion ? {
      startAdornment: /* @__PURE__ */ jsx(AdornedInput.Adornment, { children: "$" })
    } : {};
    let endAdornmentProps = {};
    if (percentageQuestion) {
      endAdornmentProps = {
        endAdornment: /* @__PURE__ */ jsx(AdornedInput.Adornment, { children: "%" })
      };
    } else if (perMonth) {
      endAdornmentProps = {
        endAdornment: /* @__PURE__ */ jsx(AdornedInput.Adornment, { children: "/mo" })
      };
    }
    return /* @__PURE__ */ jsx(FormField, { optional: true, label: /* @__PURE__ */ jsxs(Label, { children: [
      inputLabel,
      /* @__PURE__ */ jsx(InputTooltip, { toolTipHeader, toolTipStatement })
    ] }), control: /* @__PURE__ */ jsx(AdornedInput, { css: inputRootCss, ...startAdornmentProps, ...endAdornmentProps, input: /* @__PURE__ */ jsx(AdornedInput.Input, { css: inputNumberCss, type: "number", value, onChange: (e) => onChange(e) }) }) });
  }
}
export {
  RentVsBuyInputField as default
};
